import {
  IsString,
  IsOptional,
  IsBoolean,
  ValidateNested,
  IsDefined,
  ValidateIf,
} from 'class-validator';
import { Type } from 'class-transformer';

class InteractionEventDataDto {
  @IsOptional()
  @IsString()
  url?: string;

  @IsOptional()
  @IsString()
  optionId?: string | null;

  @IsOptional()
  @IsBoolean()
  newTab?: boolean;

  @IsOptional()
  @IsBoolean()
  useNofollow?: boolean;
}

export class InteractionEventDto {
  @IsDefined()
  @IsString()
  eventType!: string;

  @ValidateIf((o) => o.eventData !== null)
  @ValidateNested()
  @Type(() => InteractionEventDataDto)
  eventData!: InteractionEventDataDto | null;
}
